export var RENDER_SIZE = 512;
export var MAX_DEPTH = 4; // 16x reduction
